import { FC } from 'react';
import { PlatformTotals } from '../mock/types';
import { fmtCurrency, fmtInt } from '../utils';

type KpiHeroProps = {
  audienceUsers: number;
  platforms: PlatformTotals[];
};

export const KpiHero: FC<KpiHeroProps> = ({ audienceUsers, platforms }) => {
  const google = platforms.find((p) => p.platform === 'google');
  const meta = platforms.find((p) => p.platform === 'meta');

  const totalImpressions = (google?.impressions ?? 0) + (meta?.impressions ?? 0);
  const totalCost = (google?.cost ?? 0) + (meta?.cost ?? 0);
  const reach = meta?.reach ?? null;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 18,
      }}
    >
      <KpiCard label='Dimensione cluster attivato' value={fmtInt(audienceUsers)} caption='utenti unici inviati alle piattaforme' />
      <KpiCard label='Reach totale' badge='Meta only' value={reach !== null ? fmtInt(reach) : '—'} caption='utenti unici raggiunti' />
      <KpiCard
        label='Impression totali'
        value={fmtInt(totalImpressions)}
        captionTop='Google + Meta'
        split={[
          { color: '#1452E6', label: 'Google', value: fmtInt(google?.impressions ?? 0) },
          { color: '#0B1733', label: 'Meta', value: fmtInt(meta?.impressions ?? 0) },
        ]}
      />
      <KpiCard
        label='Costo totale'
        value={fmtCurrency(totalCost)}
        captionTop='spesa nel periodo'
        split={[
          { color: '#1452E6', label: 'Google', value: fmtCurrency(google?.cost ?? 0) },
          { color: '#0B1733', label: 'Meta', value: fmtCurrency(meta?.cost ?? 0) },
        ]}
      />
    </div>
  );
};

type KpiSplit = { color: string; label: string; value: string };

const KpiCard: FC<{
  label: string;
  value: string;
  caption?: string;
  captionTop?: string;
  badge?: string;
  split?: KpiSplit[];
}> = ({ label, value, caption, captionTop, badge, split }) => {
  return (
    <div
      style={{
        background: '#FFFFFF',
        border: '1px solid #E7EAEF',
        borderRadius: 14,
        padding: '18px 20px',
      }}
    >
      <div
        style={{
          fontSize: 12,
          color: '#58657B',
          fontWeight: 500,
          marginBottom: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <span>{label}</span>
        {badge ? (
          <span
            style={{
              fontSize: 10,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              background: 'white',
              color: '#7A8597',
              border: '1px solid #DEE2E8',
              padding: '2px 6px',
              borderRadius: 4,
            }}
          >
            {badge}
          </span>
        ) : null}
      </div>
      <div
        style={{
          fontSize: 30,
          fontWeight: 700,
          color: '#1452E6',
          letterSpacing: '-0.02em',
          fontVariantNumeric: 'tabular-nums',
          lineHeight: 1,
        }}
      >
        {value}
      </div>
      {captionTop ? <div style={{ marginTop: 8, fontSize: 11.5, color: '#58657B' }}>{captionTop}</div> : null}
      {caption ? <div style={{ marginTop: 10, fontSize: 11.5, color: '#58657B' }}>{caption}</div> : null}
      {split ? (
        <div style={{ marginTop: 10, display: 'flex', gap: 12, fontSize: 11.5, color: '#58657B' }}>
          {split.map((s) => (
            <span key={s.label}>
              <span
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: 2,
                  marginRight: 5,
                  display: 'inline-block',
                  verticalAlign: 1,
                  background: s.color,
                }}
              />
              {s.label}&nbsp;<b style={{ color: '#0B1733' }}>{s.value}</b>
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
};
